import React, { useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { set } from "react-hook-form";
import Cookies from "js-cookie";

const AddDepartment = () => {
  const [department, setDepartment] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { baseUrl, openToast,fetchDepartments } = useGlobalContext();

  async function submitDepartment() {
    setIsLoading(true);
    try {
     
      if (!department.trim()) {
        openToast("Department name cannot be empty", "error");
        return;
      }
      const response = await fetch(baseUrl + "department", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ departmentName: department }), // send the formatted data
      });

      console.log(response);
      const result = await response.json();
      if (response.status === 200) {
        console.log(result);
        openToast(result.message || "Department successfully added", "success");
        setIsLoading(false);
        navigate("/department-details");
        fetchDepartments()
      } else {
        openToast(result.message || "An error occurred", "error");
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setDepartment("");
    }
  }

  return (
    <div className="mt-5 pr-2 pb-4 pl-[10px] w-[100%] addnewrole">
      <h2 className="font-medium text-[#27004a] text-[18px]">
        Add New Department
      </h2>

      <div className="w-[100%]">
        <div className="bg-[#fff] set-shadow mt-2 p-3 rounded-md w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
          <label>Department Name</label>
          <br />
          <input
            type="text"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
            className="border-1 mt-2 pr-7 pl-3 border rounded-md w-[100%] h-[43px] text-[#aeabab] text-[15px] ] focus:outline-none"
          />
          <table className="border-1 mt-5 border w-[100%]">
            <thead className="border-1 border">
              <th className="p-2 border-r-[1px] font-medium text-left">
                Features
              </th>
              <th className="p-2 font-medium text-left">Capabilities</th>
            </thead>
            <tbody className="table-body-set">
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Clients
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="client"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="client1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="client2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="client3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Projects
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="project"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="project1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="project2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="project3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Report
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="report"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="report"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="report1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="report1"
                  >
                    {" "}
                    View Timesheets Report
                  </label>
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Staff Role
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staffrole"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="staffrole1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staffrole2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staffrole3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Setting
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="setting"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="setting"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="setting1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="setting1"
                  >
                    {" "}
                    View Timesheets Report
                  </label>
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Staff{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staff"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="staff1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staff2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="staff3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="task"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="task1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="task2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="task3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Sub Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="subtask"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[14px] cursor-pointer"
                    for="subtask1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="subtask2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="subtask3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px] whitespace-nowrap">
                  Chat Module{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="chat"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[14px] cursor-pointer"
                    for="chat"
                  >
                    Grant Access
                  </label>
                  <br />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-end gap-[10px] mt-3 text-end">
            <Link
              to="/department-details"
              className="flex items-center hover:bg-[#7526d1] py-2 pt-2 pr-5 pl-5 rounded-md text-white first-btn"
            >
              Cancel
            </Link>
            <button
              className={` ${
                isLoading == true ? "second-btn-disabled" : "second-btn"
              }`}
              onClick={submitDepartment}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;
